/**
 *
 * @param {React.KeyboardEvent<HTMLInputElement>} event
 * @return {*}  {boolean}
 */
export const isValidNumberKey = (
    event: React.KeyboardEvent<HTMLInputElement>
): boolean => {
    const validKeys = [
        'Backspace',
        'Delete',
        'Tab',
        'Enter',
        'ArrowLeft',
        'ArrowRight',
        'Home',
        'End',
    ];

    // Allow copy, paste, select all, etc.
    if (event.ctrlKey || event.metaKey) return true;

    if (validKeys.includes(event.key)) return true;

    // compare base on unicode value
    if (event.key >= '0' && event.key <= '9') return true;

    // Allow one dot for decimals
    if (event.key === '.' && !event.currentTarget.value.includes('.'))
        return true;

    // Allow negative numbers
    if (event.key === '-' && !event.currentTarget.value.includes('-'))
        return true;

    return false;
};
